import { createContext } from 'react';

import type { Documento, SituacaoTotal } from '@/services/Documentos';

export type TipoDocumento = '0' | '1';

export type FiltrosDocumentos = {
  modelo: string;
  cfop: string;
  cst: string;
  fornecedor: string;
  numeroDoc: string;
  status: string;
  evento: string;
  chaveNota: string;
  /** Busca única do topo (SPEC-018): chave, número, CNPJ ou participante. */
  busca: string;
  /** Finalidade da NF-e (`finNFe`): '1', '4', '5', '6' ou '' para todas (SPEC-018). */
  finalidade: string;
};

export type FiltrosHeaderSnapshot = {
  empresaId: string | null;
  empresaCnpjs: string | null;
  dataInicio: string | null;
  dataFim: string | null;
};

export type DocumentosModeloItem = {
  key: string;
  nome: string;
  documentos: Documento[];
  total: number;
  situacoes?: SituacaoTotal[];
  /** Soma do valor das notas do grupo; ausente quando a API ainda não o publica. */
  valorTotal?: number;
};

export type DocumentosListaData = {
  documentosPorModelo: DocumentosModeloItem[];
  documentosPorModeloCompleto: DocumentosModeloItem[];
  documentos: Documento[];
  totalItens: number;
  isLoading: boolean;
  isFetching: boolean;
  /** Ainda não há resposta nenhuma — a busca inicial roda logo depois da montagem. */
  isPending: boolean;
  isError: boolean;
  refetch: () => unknown;
};

export type DocumentosContextValue = {
  tipoDocumento: TipoDocumento;
  setTipoDocumento: (tipo: TipoDocumento) => void;

  filtros: FiltrosDocumentos;
  filtrosHeaderAplicados: FiltrosHeaderSnapshot;

  handleBuscar: () => void;
  handleLimparFiltrosGlobais: () => void;
  handleAplicarFiltros: (filtro: Partial<FiltrosDocumentos>) => void;

  refetchDocumentos: () => void;

  /**
   * Conta cada "Buscar" e cada "Limpar filtros": o que depende só da empresa e do período (o aviso do Recebimento)
   * refaz junto. A busca, a finalidade e a janela Filtros não contam.
   */
  aplicacao: number;

  dadosEntradas: DocumentosListaData;
  dadosSaidas: DocumentosListaData;
};

export const DocumentosContext = createContext<DocumentosContextValue | null>(null);
